import { globalFetch } from "foundation/js/api"

export default {
    namespaced: true,
    state: {
        signUpCompleteShowReceipt: false,
        signUpEventId: null,
        isSubmitting: false
    },
    mutations: {
        completeSignup(state) {
            state.signUpCompleteShowReceipt = true
        },
        set_signUpEventId(state, eventId) {
            state.signUpEventId = eventId
        },
        set_submitting(state, isSubmitting) {
            state.isSubmitting = isSubmitting
        }
    },
    actions: {
        signUpToEvent(context, payload) {
            const url = process.env.EVENTSIGNUP
            const method = process.env.FETCHMETHOD
            const headers = new Headers()
            headers.append('Content-Type', 'application/json')
            const init = {
                headers,
                method: 'POST',
                body: JSON.stringify(payload)
            }

            context.commit('set_submitting', true)

            globalFetch(url, init)
                .then((response) => {
                    if (response.ok) {
                        context.commit('completeSignup')
                    }
                    throw new Error(response.error)
                })
                .catch((err) => {
                    console.error('Der skete en fejl ved tilmelding', err)
                })
                .finally(() => {
                    context.commit('set_submitting', false)
                })
        }
    }
}
